<template>
  <base-icon-button-assignment :disabled="disabled"
                               @click="onClick"/>
</template>

<script>
  import BaseIconButtonAssignment from '@/components/base-components/base-icons/BaseIconButtonAssignment';
  import { sendPdfToUser } from '@/helpers/pdfDownloadFunctions';

  export default {
    name: 'ActionDownloadReportPdf',
    components: { BaseIconButtonAssignment },
    props: {
      proposal: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      onClick() {
        return this.$listeners.click || this.downloadExperimentReport;
      },
      disabled() {
        return this.$attrs.disabled || !this.hasProperty(this.proposal, 'experiment_report');
      },
    },
    methods: {
      async downloadExperimentReport() {
        if (this.hasProperty(this.proposal, 'experiment_report')) {
          const response = await this.axios.get(`/${this.getId(this.proposal)}/experiment-report/pdf`);
          const { error } = response.data;
          if (error) {
            this.$notify({ type: 'error', title: error });
          } else {
            sendPdfToUser(response.request.responseURL);
          }
        }
      },
    },
  };
</script>

<style scoped>

</style>
